import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const SearchModeSwitcherContainer = ({
	testId,
	children,
	isSearchModeSwitcherOnLeft,
}: {
	testId: string;
	children: React.ReactNode;
	isSearchModeSwitcherOnLeft: boolean;
}): React.JSX.Element => (
	// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
	<Box xcss={getContainerXcss(isSearchModeSwitcherOnLeft)} testId={testId}>
		{children}
	</Box>
);

const getContainerXcss = (isSearchModeSwitcherOnLeft: boolean) => {
	if (isSearchModeSwitcherOnLeft) {
		return [searchModeSwitcherBaseContainerStyle];
	}
	return [searchModeSwitcherBaseContainerStyle, searchModeSwitcherRightAlignedContainerStyle];
};

const searchModeSwitcherBaseContainerStyle = xcss({
	alignSelf: 'start',
	// The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
	// However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
	// The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
	minHeight: token('space.400'),
	display: 'flex',
});

const searchModeSwitcherRightAlignedContainerStyle = xcss({
	marginTop: 'space.025',
	marginLeft: 'space.100',
});
